import { isArray } from "underscore";
import { useSelector } from "react-redux";
import Constants from "src/helper/Constants";

/**
 * common file for adobeDataLayer
 * author: Ramya Kannan
 */
class HelperAdobeEvent {
  static trackingAdobeEvent(object) {
    let dataPoints = object;
    let cartType, bomType;
    let existingAvnetInfo =
      window.adobeDataLayer && window.adobeDataLayer[0]?._avnet;
    window.adobeDataLayer = window.adobeDataLayer || [];
    let eventType = localStorage.getItem("adobeEventType");

    if (eventType !== undefined && eventType !== null) {
      switch (eventType) {
        case "registrationStart":
          this.registrationEvent(dataPoints, existingAvnetInfo, eventType);
          break;
        case "registrationComplete":
          this.registrationEvent(dataPoints, existingAvnetInfo, eventType);
          break;
        case "bomFileUpload":
          this.bomFileUploadEvent(dataPoints, existingAvnetInfo);
          break;
        case "renameBom":
          this.renameBoMEvent(dataPoints, existingAvnetInfo);
          break;
        case "addToBOM":
          this.addToBOMEvent(dataPoints, existingAvnetInfo);
          break;
        case "createBOM":
          this.createBOMEvent(dataPoints, existingAvnetInfo);
          break;
        case "bomOpened":
          this.bomOpenedEvent(dataPoints, existingAvnetInfo);
          break;
        case "bomProductRemoval":
          this.bomProductRemovalEvent(dataPoints, existingAvnetInfo);
          break;
        case "bomProdSelectionMultipleResolved":
          this.bomMultipleMatchesEvent(dataPoints, existingAvnetInfo);
          break;
        case "bomProdRemoveMultipleResolved":
          bomType = "bomProdRemoveMultipleResolved";
          this.removeMatchesEvent(dataPoints, existingAvnetInfo, bomType);
          break;
        case "bomProdRemoveNoMatchesResolved":
          bomType = "bomProdRemoveNoMatchesResolved";
          this.removeMatchesEvent(dataPoints, existingAvnetInfo, bomType);
          break;

        case "bomNoMatchesResolved":
          this.bomNoMatchesEvent(dataPoints, existingAvnetInfo);
          break;
        case "bomQuicklyAddPart":
          this.bomQuicklyAddPartEvent(dataPoints, existingAvnetInfo);
          break;
        case "downloads":
          this.downLoadEvent(dataPoints, existingAvnetInfo);
          break;
        case "miBomDownload":
          this.miBOMdownLoadEvent(dataPoints, existingAvnetInfo);
          break;
        case "emailBOMEvent":
          this.emailBomEvent(dataPoints, existingAvnetInfo);
          break;
        case "addToQuote":
          cartType = "addToQuote";
          this.addToQuoteEvent(dataPoints, existingAvnetInfo, cartType);
          break;
        case "addToQuoteFromBOM":
          cartType = "addToQuoteFromBOM";
          this.addToQuoteEvent(dataPoints, existingAvnetInfo, cartType);
          break;
        case "quoteCartAdditionEvent":
          cartType = "quoteCartAddition";
          this.quoteEvent(dataPoints, existingAvnetInfo, cartType);
          break;
        case "quoteCartRemovalEvent":
          cartType = "quoteCartRemoval";
          this.quoteEvent(dataPoints, existingAvnetInfo, cartType);
          break;
        case "quoteSubmissionEvent":
          cartType = "quoteSubmission";
          this.quoteEvent(dataPoints, existingAvnetInfo, cartType);
          break;
        case "addToCartEvent":
          cartType = "addToCart";
          this.cartEvent(dataPoints, existingAvnetInfo, cartType);
          break;
        case "QuoteCartViewEvent":
          cartType = "quoteCartView";
          this.cartEvent(dataPoints, existingAvnetInfo, cartType);
          break;
        case "cartViewEvent":
          cartType = "cartView";
          this.cartEvent(dataPoints, existingAvnetInfo, cartType);
          break;
        case "cartRemovalEvent":
          cartType = "cartRemoval";
          this.cartEvent(dataPoints, existingAvnetInfo, cartType);
          break;
        case "cartCheckout":
          eventType = "cartCheckout";
          this.cartCheckoutEvent(dataPoints, existingAvnetInfo, eventType);
          break;
        case "quoteCartCheckout":
          eventType = "quoteCartCheckout";
          this.cartCheckoutEvent(dataPoints, existingAvnetInfo, eventType);
          break;
        case "checkOut":
          this.checkOutStepEvent(dataPoints, existingAvnetInfo);
          break;
        case "exportEvent":
          this.exportEvent(dataPoints, existingAvnetInfo);
          break;
        case "purchaseEvent":
          this.purchaseEvent(dataPoints, existingAvnetInfo);
          break;
        case "typeHeadSearch":
          this.typeHeadSearchEvent(dataPoints, existingAvnetInfo);
          break;
        case "internalSearchEvent":
          this.internalSearchEvent(dataPoints, existingAvnetInfo);
          break;
        case "searchFilterEvent":
          this.searchFilterEvent(dataPoints, existingAvnetInfo);
          break;
        case "productViewEvent":
          this.productViewEvent(dataPoints, existingAvnetInfo);
          break;
        case "errorEvent":
          this.errorDetailsEvent(dataPoints, existingAvnetInfo);
          break;
        case "formStartEvent":
          this.formEvents(dataPoints, existingAvnetInfo, "formStart");
          break;
        case "formErrorEvent":
          this.formEvents(dataPoints, existingAvnetInfo, "formError");
          break;
        case "foreCastEvent":
          this.foreCastEvent(dataPoints, existingAvnetInfo);
          break;
        case "CTAClickEvent":
          this.CTAClickEvents(dataPoints, existingAvnetInfo);
          break;
        case Constants.analyticsEvent.ADD_NEWARK_ITEM:
           this.cartEvent(dataPoints, existingAvnetInfo, Constants.analyticsEvent.ADD_NEWARK_ITEM);
        default:
          break;
      }
    }
  }

  static formEvents(dataPoints, avnetInfo, eventType) {
    let formValues = dataPoints.formDetails;
    const formEvent = {
      event: eventType,
      _avnet: {
        formDetails: {
          formName: formValues.formName,
          formType: formValues.formType,
          formId: formValues.formId,
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };
    if (eventType === "formError") {
      let dupFormDet = { ...formEvent._avnet.formDetails };
      dupFormDet.formErrorDetails = "";
      formEvent._avnet.formDetails = dupFormDet;
    }
    window.adobeDataLayer.push(formEvent);
    this.removeLocalStorageEvent();
  }

  static CTAClickEvents(dataPoints, avnetInfo) {
    let linkDetails = dataPoints.linkDetails;
    const clickEvent = {
      event: "ctaClick",
      _avnet: {
        linkInfo: {
          linkName: linkDetails.linkName,
          linkUrl: linkDetails.linkUrl,
          linkLocation: linkDetails.linkLocation,
          linkType: linkDetails.linkType,
          linkComponent: linkDetails.linkComponent,
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };
    window.adobeDataLayer.push(clickEvent);
    this.removeLocalStorageEvent();
  }

  static typeHeadSearchEvent(dataPoints, avnetInfo) {
    let searchDetails = dataPoints.searchDetails;
    const searchEvent = {
      event: "typeheadSearch",
      _avnet: {
        internalSearchInfo: {
          searchType: "Internal",
          searchTerm: searchDetails.searchTerm,
          searchTab: searchDetails.searchTab,
        },
        linkInfo: {
          linkName: searchDetails.linkName,
          linkUrl: searchDetails.linkUrl,
          linkLocation: "typeheadSearchResults",
          linkType: "link",
          linkComponent: "typeheadPopup",
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };

    window.adobeDataLayer.push(searchEvent);
    this.removeLocalStorageEvent();
  }

  static internalSearchEvent(dataPoints, avnetInfo) {
    let searchDetails = dataPoints.searchDetails;
    const searchEvent = {
      event: "internalSearchCompleted",
      _avnet: {
        internalSearchInfo: {
          searchType: "internal",
          searchTerm: searchDetails.searchTerm,
          searchResultsCount: searchDetails.count,
          numberOfPagesReturned: searchDetails.pageCount,
          searchTab: "Products",
          searchPagination: searchDetails.isPagination,
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };
    window.adobeDataLayer.push(searchEvent);
    this.removeLocalStorageEvent();
  }

  static searchFilterEvent(dataPoints, avnetInfo) {
    let filterDetails = dataPoints.filterDetails;
    const searchEvent = {
      event: "searchFiltersApplied",
      _avnet: {
        internalSearchInfo: {
          searchType: "Internal",
          searchTerm: filterDetails.searchTerm || "",
          filtersApplied: filterDetails.appliedFilterArr,
          filterAppliedCount: filterDetails.appliedFltCount,
          searchResultsCount: filterDetails.searchCount,
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };

    window.adobeDataLayer.push(searchEvent);
    this.removeLocalStorageEvent();
  }

  static foreCastEvent(dataPoints, avnetInfo) {
    let filterDetails = dataPoints.filterDetails;
    const foreCastEvnt = {
      event: "forecastView",
      _avnet: {
        bomForecastFilterInfo: {
          filtersApplied: filterDetails.appliedFilterArr,
          filterAppliedCount: filterDetails.appliedFltCount,
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };

    window.adobeDataLayer.push(foreCastEvnt);
    this.removeLocalStorageEvent();
  }

  static errorDetailsEvent(dataPoints, avnetInfo) {
    let errorValues = dataPoints.errorDetails;
    const errorDT = {
      event: "errorDetails",
      _avnet: {
        errorInfo: {
          errorName: errorValues.errorName,
          errorMessage: errorValues.errorMSG,
          errorLocation: errorValues.location,
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };

    window.adobeDataLayer.push(errorDT);
    this.removeLocalStorageEvent();
  }

  static formsErrorEvent(dataPoints, avnetInfo) {
    let errorValues = dataPoints.errorValues;
    const errorDT = {
      event: "formErrror",
      _avnet: {
        formDetails: {
          formName: "<<Name of the form submitted>>",
          formType: "<<Form Type>",
          formId: "<<ID of the form submitted>>",
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };

    window.adobeDataLayer.push(errorDT);
    this.removeLocalStorageEvent();
  }

  static registrationEvent(dataPoints, avnetInfo, eventType) {
    let existingAvnetInfo = avnetInfo;
    let userDetail = dataPoints;
    const registerCompleteEvent = {
      event: eventType,
      _avnet: {
        identitymap: {
          userID: [{ id: userDetail?.data }] || "",
        },
        pageInfo: existingAvnetInfo?.pageInfo,
        userInfo: existingAvnetInfo?.userInfo,
      },
    };
    window.adobeDataLayer.push(registerCompleteEvent);
    this.removeLocalStorageEvent();
  }

  static bomFileUploadEvent(dataPoints, avnetInfo) {
    let bomDetails = dataPoints.bomDetails;
    let bomDetailsTable = dataPoints.bomDetailsTable;
    let existingAvnetInfo = avnetInfo;
    window.adobeDataLayer.push({
      event: "bomFileUpload",
      _avnet: {
        bomInfo: {
          bomId: bomDetails.bomId,
          bomTitle: bomDetails.bomName,
          bomProjectName: bomDetails.projectName || "",
          newBOM: bomDetails.newBOM,
          sourceofBOM: bomDetails.source,
          exactMatchesReturned: bomDetailsTable?.Exact?.count,
          multipleMatchesReturned: bomDetailsTable?.Multiple?.count,
          noMatchesReturned: bomDetailsTable?.NoMatch?.count,
        },
        pageInfo: existingAvnetInfo?.pageInfo,
        userInfo: existingAvnetInfo?.userInfo,
      },
    });
    this.removeLocalStorageEvent();
  }

  static renameBoMEvent(dataPoints, avnetInfo) {
    let bomDetails = dataPoints.bomDetails;
    let bomDetailsTable = dataPoints.bomDetailsTable;
    let existingAvnetInfo = avnetInfo;
    window.adobeDataLayer.push({
      event: "renameBom",
      _avnet: {
        bomInfo: {
          bomId: bomDetails.bomId,
          bomTitle: bomDetails.bomName,
          bomProjectName: bomDetails.projectName || "",
          newBOM: bomDetails.newBOM,
          sourceofBOM: bomDetails.source,
          exactMatchesReturned: bomDetailsTable?.Exact?.count,
          multipleMatchesReturned: bomDetailsTable?.Multiple?.count,
          noMatchesReturned: bomDetailsTable?.NoMatch?.count,
        },
        pageInfo: existingAvnetInfo?.pageInfo,
        userInfo: existingAvnetInfo?.userInfo,
      },
    });
    this.removeLocalStorageEvent();
  }

  static addToBOMEvent(dataPoints, avnetInfo) {
    let prodDetails = dataPoints.prodDetails;
    let bomDetails = dataPoints.bomDetails;
    let setProduct = isArray(prodDetails) ? prodDetails : [prodDetails];
    const addtoBOM = {
      event: "addToBOM",
      _avnet: {
        productListItems: this.arrangeBOMProductsLists(setProduct),
        bomInfo: {
          bomId: bomDetails.bomID || bomDetails.bomId,
          bomTitle: bomDetails.bomName,
          newBOM: bomDetails.newBOM,
          sourceofBOM: bomDetails.source,
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };

    window.adobeDataLayer.push(addtoBOM);
    this.removeLocalStorageEvent();
  }

  static createBOMEvent(dataPoints, avnetInfo) {
    let prodDetails = dataPoints.prodDetails;
    let bomDetails = dataPoints.bomDetails;
    let setProduct = isArray(prodDetails) ? prodDetails : [prodDetails];
    const createBOM = {
      event: "createBOM",
      _avnet: {
        productListItems: this.arrangeBOMProductsLists(setProduct),
        bomInfo: {
          bomId: bomDetails.bomID,
          bomTitle: bomDetails.bomName,
          bomProjectName: bomDetails.projectName || "",
          newBOM: bomDetails.newBOM,
          sourceofBOM: bomDetails.source,
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };

    window.adobeDataLayer.push(createBOM);
    this.removeLocalStorageEvent();
  }

  static bomOpenedEvent(dataPoints, avnetInfo) {
    let bomDetails = dataPoints.bomDetails;
    let bomDetailsTable = dataPoints.bomDetailsTable;
    let prodDetails = dataPoints.prodDetails;

    const bomOpen = {
      event: "bomOpened",
      _avnet: {
        productListItems: this.arrangeBOMProductsLists(prodDetails),
        bomInfo: {
          bomId: bomDetails.bomId,
          bomTitle: bomDetails.bomName,
          newBOM: bomDetails.newBOM,
          sourceofBOM: bomDetails.source,
          bomProjectName: bomDetails.projectName || "",
          exactMatchesReturned: bomDetailsTable?.Exact?.count,
          multipleMatchesReturned: bomDetailsTable?.Multiple?.count,
          noMatchesReturned: bomDetailsTable?.NoMatch?.count,
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };

    window.adobeDataLayer.push(bomOpen);
    this.removeLocalStorageEvent();
  }

  static bomProductRemovalEvent(dataPoints, avnetInfo) {
    let bomDetails = dataPoints.bomDetails;
    let prodDetails = dataPoints.prodDetails;

    const bomProductRemoval = {
      event: "bomProductRemoval",
      _avnet: {
        productListItems: this.arrangeBOMProductsLists([prodDetails]),
        bomInfo: {
          bomId: bomDetails.bomId,
          bomTitle: bomDetails.bomName,
          newBOM: bomDetails.newBOM,
          sourceofBOM: bomDetails.source,
          bomProjectName: bomDetails.projectName || "",
          exactMatchesReturned: bomDetails.exactMatchCount,
          multipleMatchesReturned: bomDetails.multipleMatchCount,
          noMatchesReturned: bomDetails.nomatchCount,
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };

    window.adobeDataLayer.push(bomProductRemoval);
    this.removeLocalStorageEvent();
  }

  static bomMultipleMatchesEvent(dataPoints, avnetInfo) {
    let bomDetails = dataPoints.bomDetails;
    let prodDetails = dataPoints.prodDetails;

    const MultipleBOM = {
      event: "bomProdSelectionMultipleResolved",
      _avnet: {
        productListItems: this.arrangeBOMProductsLists(prodDetails),
        bomInfo: {
          bomId: bomDetails.bomId,
          bomTitle: bomDetails.bomName,
          bomProjectName: bomDetails.projectName || "",
          newBOM: bomDetails.newBOM,
          sourceofBOM: bomDetails.source,
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };

    window.adobeDataLayer.push(MultipleBOM);
    this.removeLocalStorageEvent();
  }

  static removeMatchesEvent(dataPoints, avnetInfo, bomType) {
    let bomDetails = dataPoints.bomDetails;
    let partNumber = dataPoints.partNumber;
    const removePart = {
      event: bomType,
      _avnet: {
        productListItems: [
          {
            merchandising: {
              partNumberEntered: partNumber,
              dateTimestamp: this.timeStamp(),
            },
          },
        ],

        bomInfo: {
          bomId: bomDetails.bomId,
          bomTitle: bomDetails.bomName,
          bomProjectName: bomDetails.projectName || "",
          newBOM: bomDetails.newBOM,
          sourceofBOM: bomDetails.source,
          exactMatchesReturned: bomDetails.exactMatchCount,
          multipleMatchesReturned: bomDetails.multipleMatchCount,
          noMatchesReturned: bomDetails.nomatchCount,
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };

    window.adobeDataLayer.push(removePart);
    this.removeLocalStorageEvent();
  }

  static bomNoMatchesEvent(dataPoints, avnetInfo) {
    let bomDetails = dataPoints.bomDetails;
    let prodDetails = dataPoints.prodDetails;

    const NoMatchesBOM = {
      event: "bomNoMatchesResolved",
      _avnet: {
        productListItems: this.arrangeBOMProductsLists([prodDetails]),
        bomInfo: {
          bomId: bomDetails.bomId,
          bomTitle: bomDetails.bomName,
          newBOM: bomDetails.newBOM,
          sourceofBOM: bomDetails.source,
          bomProjectName: bomDetails.projectName || "",
          exactMatchesReturned: bomDetails.exactMatchCount,
          multipleMatchesReturned: bomDetails.multipleMatchCount,
          noMatchesReturned: bomDetails.nomatchCount,
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };

    window.adobeDataLayer.push(NoMatchesBOM);
    this.removeLocalStorageEvent();
  }

  static bomQuicklyAddPartEvent(dataPoints, avnetInfo) {
    let bomDetails = dataPoints.bomDetails;
    let bomDetailsTable = dataPoints.bomDetailsTable;
    let prodDetails = dataPoints.prodDetails;

    const addPart = {
      event: "bomQuicklyAddPart",
      _avnet: {
        productListItems: this.arrangeBOMProductsLists([prodDetails]),
        bomInfo: {
          bomId: bomDetails.bomId,
          bomTitle: bomDetails.bomName,
          newBOM: bomDetails.newBOM,
          sourceofBOM: bomDetails.source,
          bomProjectName: bomDetails.projectName || "",
          exactMatchesReturned: bomDetailsTable?.Exact?.count,
          multipleMatchesReturned: bomDetailsTable?.Multiple?.count,
          noMatchesReturned: bomDetailsTable?.NoMatch?.count,
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };

    window.adobeDataLayer.push(addPart);
    this.removeLocalStorageEvent();
  }

  static downLoadEvent(dataPoints, avnetInfo) {
    let dwdDetails = dataPoints.dwdDetails;
    let getBomInfo;

    const commonDownload = {
      event: "downloads",
      _avnet: {
        downloadInfo: {
          dlFileExtenstion: dwdDetails.fileType,
          dlFileName: dwdDetails.fileName,
          timeStamp: this.timeStamp(),
          downloadType: dwdDetails.dwdType,
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };

    window.adobeDataLayer.push(commonDownload);
    this.removeLocalStorageEvent();
  }

  static miBOMdownLoadEvent(dataPoints, avnetInfo) {
    let bomDetails = dataPoints.bomDetails;
    let dwdDetails = dataPoints.dwdDetails;
    const commonDownload = {
      event: "miBomDownload",
      _avnet: {
        downloadInfo: {
          dlFileExtenstion: dwdDetails.fileType,
          dlFileName: dwdDetails.fileName,
          timeStamp: this.timeStamp(),
          downloadType: dwdDetails.dwdType,
        },
        bomInfo: {
          bomId: bomDetails.bomId,
          bomTitle: bomDetails.bomName,
          newBOM: bomDetails.newBOM,
          sourceofBOM: bomDetails.source,
          bomProjectName: bomDetails.projectName || "",
          exactMatchesReturned: bomDetails.exactMatchCount,
          multipleMatchesReturned: bomDetails.multipleMatchCount,
          noMatchesReturned: bomDetails.nomatchCount,
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };

    window.adobeDataLayer.push(commonDownload);
    this.removeLocalStorageEvent();
  }

  static emailBomEvent(dataPoints, avnetInfo) {
    let bomDetails = dataPoints.emailBomdetails;
    let existingAvnetInfo = avnetInfo;
    window.adobeDataLayer.push({
      event: "emailBOM",
      _avnet: {
        bomInfo: {
          bomId: bomDetails.bomId,
          bomTitle: bomDetails.bomName,
          newBOM: bomDetails.newBOM,
          sourceOfBOM: bomDetails.source,
          bomProjectName: bomDetails.projectName || "",
          exactMatchesReturned: bomDetails.exactMatchCount,
          multipleMatchesReturned: bomDetails.multipleMatchCount,
          noMatchesReturned: bomDetails.nomatchCount,
        },
        pageInfo: existingAvnetInfo?.pageInfo,
        userInfo: existingAvnetInfo?.userInfo,
      },
    });
    this.removeLocalStorageEvent();
  }

  static addToQuoteEvent(dataPoints, avnetInfo, quoteCartType) {
    let productDetails = dataPoints.prodDetails;
    let cartDetails = dataPoints.cartDetails;
    let bomDetails = dataPoints.bomDetails;
    productDetails = isArray(productDetails)
      ? productDetails
      : [productDetails];
    let quoteEventObj = {
      event: quoteCartType,
      _avnet: {
        productListItems: this.arrangeProductsLists(
          productDetails,
          cartDetails,
          quoteCartType
        ),
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };
    if (
      (cartDetails.additionSource === "BOM" ||
        cartDetails.additionSource === "BOMQuote") &&
      bomDetails
    ) {
      let bomInfo = {
        bomId: bomDetails.bomId,
        bomTitle: bomDetails.bomName,
        bomProjectName: bomDetails.projectName || "",
        newBOM: bomDetails.newBOM,
        sourceofBOM: bomDetails.source,
      };
      quoteEventObj._avnet.bomInfo = bomInfo;
    }

    window.adobeDataLayer.push(quoteEventObj);
    this.removeLocalStorageEvent();
  }

  static quoteEvent(dataPoints, avnetInfo, quoteCartType) {
    let productDetails = dataPoints.prodDetails;
    let cartDetails = dataPoints.cartDetails;
    let bomDetails = dataPoints.bomDetails;
    productDetails = isArray(productDetails)
      ? productDetails
      : [productDetails];
    let quoteEventObj = {
      event: quoteCartType,
      _avnet: {
        productListItems: this.arrangeProductsLists(
          productDetails,
          cartDetails,
          quoteCartType
        ),
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };
    if (cartDetails?.additionSource === "BOM" && bomDetails) {
      let bomInfo = {
        bomId: bomDetails.bomId,
        bomTitle: bomDetails.bomName,
        bomProjectName: bomDetails.projectName || "",
        newBOM: bomDetails.newBOM,
        sourceofBOM: bomDetails.source,
        exactMatchesReturned: bomDetails.exactMatchCount,
        multipleMatchesReturned: bomDetails.nomatchCount,
        noMatchesReturned: bomDetails.multipleMatchCount,
      };
      quoteEventObj._avnet.bomInfo = bomInfo;
    }
    if (cartDetails) {
      let ecommerce = {
        cartID: productDetails[0].cartId || "",
        quoteID: productDetails[0].quoteID || cartDetails?.quoteID || "",
        quoteType: cartDetails?.quoteType || "",
      };
      quoteEventObj._avnet.ecommerce = ecommerce;
    }

    window.adobeDataLayer.push(quoteEventObj);
    this.removeLocalStorageEvent();
  }

  static cartEvent(dataPoints, avnetInfo, cartType) {
    let productDetails = dataPoints.prodDetails;
    let cartDetails = dataPoints?.cartDetails;
    let bomDetails = dataPoints?.bomDetails;
    productDetails = isArray(productDetails)
      ? productDetails
      : [productDetails];
    let cartEventObj = {
      event: cartType,
      _avnet: {
        productListItems: this.arrangeProductsLists(
          productDetails,
          cartDetails,
          cartType
        ),
        ecommerce: {
          cartID:
            cartDetails?.cartId ||
            productDetails?.cartId ||
            productDetails[0]?.cartId,
          quoteID: productDetails[0].quoteID || cartDetails?.quoteID || "",
          quoteType: cartDetails?.quoteType || "",
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };

    if (cartDetails?.additionSource === "BOM" || cartType == Constants.analyticsEvent.ADD_NEWARK_ITEM) {
      let bomInfo = {
        bomId: bomDetails.bomId,
        bomTitle: bomDetails.bomName,
        bomProjectName: bomDetails.projectName || "",
        newBOM: bomDetails.newBOM,
        sourceofBOM: bomDetails.source,
        exactMatchesReturned: bomDetails.exactMatchCount,
        multipleMatchesReturned: bomDetails.multipleMatchCount,
        noMatchesReturned: bomDetails.nomatchCount,
      };
      cartEventObj._avnet.bomInfo = bomInfo;
    }

    if (cartDetails?.quoteType) {
      let copyEcommerce = { ...cartEventObj._avnet.ecommerce };
      copyEcommerce.quoteID =
        productDetails[0].quoteID || cartDetails?.quoteID || "";
      copyEcommerce.quoteType = cartDetails?.quoteType;
      cartEventObj._avnet.ecommerce = copyEcommerce;
    }

    if (cartType === "cartRemoval") {
      let isCartView = window.adobeDataLayer[1]?.event;
      let pdLength = window.adobeDataLayer[1]?._avnet?.productListItems?.length;
      if (isCartView === "cartView") {
        window.adobeDataLayer[1]?._avnet?.productListItems.splice(0, pdLength);
      }
    }

    if (cartType == Constants.analyticsEvent.ADD_NEWARK_ITEM) {
      delete cartEventObj['_avnet']['ecommerce'];
    }

    window.adobeDataLayer.push(cartEventObj);

    this.removeLocalStorageEvent();
  }

  static exportEvent(dataPoints, avnetInfo) {
    let productDetails = dataPoints.prodDetails;
    let cartDetails = dataPoints.cartDetails;
    let bomDetails = dataPoints.bomDetails;
    let exportDetails = dataPoints.exportDetails;
    let QuoteDetails = dataPoints.QuoteDetails;
    productDetails = isArray(productDetails)
      ? productDetails
      : [productDetails];
    let exportEvntObj = {
      event: "exports",
      _avnet: {
        exportInfo: {
          exportFileExtension: exportDetails.fileExtension,
          exportType: exportDetails.exportType,
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };

    if (exportDetails?.exportType === "BOM") {
      let bomInfo = {
        bomId: bomDetails.bomId,
        bomTitle: bomDetails.bomName,
        bomProjectName: bomDetails.projectName || "",
        newBOM: bomDetails.newBOM,
        sourceofBOM: bomDetails.source,
      };
      exportEvntObj._avnet.bomInfo = bomInfo;
    } else if (exportDetails?.exportType === "Cart") {
      let prodDetailsMAk = this.arrangeProductsLists(
        productDetails,
        cartDetails
      );
      exportEvntObj._avnet.productListItems = prodDetailsMAk;
    } else if (exportDetails?.exportType === "Quote") {
      let quoteInfo = {
        quoteID: QuoteDetails?.quoteID,
        quoteType: QuoteDetails?.quoteType,
      };
      exportEvntObj._avnet.quoteInfo = quoteInfo;
    }

    window.adobeDataLayer.push(exportEvntObj);
    this.removeLocalStorageEvent();
  }

  static productViewEvent(dataPoints, avnetInfo) {
    let productDetails = dataPoints.prodDetails;
    productDetails = isArray(productDetails)
      ? productDetails
      : [productDetails];
    let cartEventObj = {
      event: "productView",
      _avnet: {
        productListItems: this.arrangeProductsLists(productDetails),
        ecommerce: {
          currency: productDetails[0]?.currency || window.mct,
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };
    window.adobeDataLayer.push(cartEventObj);
    this.removeLocalStorageEvent();
  }

  static cartCheckoutEvent(dataPoints, avnetInfo, eventType) {
    let productDetails = dataPoints.prodDetails;
    let cartDetails = dataPoints.cartDetails;
    let setProduct = isArray(productDetails)
      ? productDetails
      : [productDetails];

    let checkoutEvnt = {
      event: eventType,
      _avnet: {
        productListItems: this.arrangeProductsLists(setProduct, cartDetails),
        ecommerce: {
          cartID: setProduct[0].cartId,
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };
    if (cartDetails?.quoteID) {
      let copyEcommerce = { ...checkoutEvnt._avnet.ecommerce };
      copyEcommerce.quoteID = cartDetails?.quoteID;
      copyEcommerce.quoteType = cartDetails?.quoteType;
      checkoutEvnt._avnet.ecommerce = copyEcommerce;
    }
    window.adobeDataLayer.push(checkoutEvnt);
    this.removeLocalStorageEvent();
  }

  static checkOutStepEvent(dataPoints, avnetInfo) {
    let productDetails = dataPoints.prodDetails;
    let stepType = dataPoints.stepType;
    let cartData = dataPoints.cartData;
    let setProduct = isArray(productDetails)
      ? productDetails
      : [productDetails];
    let stepEvent = {
      event: stepType,
      _avnet: {
        productListItems: this.arrangeProductsLists(setProduct, cartData),
        ecommerce: {
          cartID: setProduct[0].cartId,
        },
        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };
    if (cartData?.quoteID) {
      let copyEcommerce = { ...stepEvent._avnet.ecommerce };
      copyEcommerce.quoteID = cartData.quoteID;
      copyEcommerce.quoteType = cartData.quoteType;
      stepEvent._avnet.ecommerce = copyEcommerce;
    }
    window.adobeDataLayer.push(stepEvent);
    this.removeLocalStorageEvent();
  }

  static purchaseEvent(dataPoints, avnetInfo) {
    let orderDetails = dataPoints.orderDetail;
    let cartData = dataPoints.cartData;
    let productDetails = dataPoints.prodData;
    let paymentDetails = dataPoints.paymentDetails;
    let purchaseEvent = {
      event: "purchase",
      _avnet: {
        payments: {
          currencyCode: productDetails[0]?.currency || window.mct,
          paymentAmount: orderDetails?.orderEstimation?.orderTotal || "",
          paymentType: orderDetails?.paymentMethod || "",
          transactionID: orderDetails?.purchaseOrderNumber,
        },
        productListItems: this.arrangeProductsLists(productDetails),
        ecommerce: {
          cartID: productDetails[0].cartId,
        },
        orderDetails: {
          orderPriceTotal: paymentDetails.total,
          orderID: orderDetails.orderId,
          taxAmount: orderDetails?.orderEstimation?.estimatedTax,
          shippingAmount : orderDetails?.orderEstimation?.estimatedShipping
        },

        pageInfo: avnetInfo?.pageInfo,
        userInfo: avnetInfo?.userInfo,
      },
    };
    if (cartData?.quoteID) {
      let copyEcommerce = { ...purchaseEvent._avnet.ecommerce };
      copyEcommerce.quoteID = cartData.quoteID;
      copyEcommerce.quoteType = cartData.quoteType;
      purchaseEvent._avnet.ecommerce = copyEcommerce;
    }
    window.adobeDataLayer.push(purchaseEvent);
    this.removeLocalStorageEvent();
  }

  static arrangeBOMProductsLists(prodDetails) {
    if (prodDetails) {
      let productListItems = [];
      prodDetails.forEach((prodData, key) => {
        let obj = {
          SKU: prodData?.ItemNumber || prodData?.itemNumber,
          name: prodData?.ERPPartNumber || prodData?.erpPartNumber,
          currencyCode: prodData?.currency || window?.mct,
          quantity: prodData?.Quantity || prodData?.quantity,
          priceTotal: prodData?.subtotal ? prodData?.subtotal.toFixed(2) : "",
          productImageUrl: prodData?.AssetURL || "",
          merchandising: {
            erpPartKey: prodData?.ERPPartNumber || prodData?.partNumber,
            pimPartKey: prodData?.ItemNumber || prodData.itemNumber,
            supplierID: prodData?.ERPSupplierCode || "", //Phani
            supplierPartNumber: prodData?.supplierPartNumber || "", //Phani
            manufacturerID:
              prodData.ManufacturerCode ||
              prodData.manufacturerCode ||
              prodData.ERPManufacturerCode ||
              "",
            manufacturerName:
              prodData.ManufacturerName ||
              prodData.manufacturerName ||
              prodData.ERPManufacturerName ||
              "",
            manufacturerPartNumber:
              prodData.manufacturerPartNumber ||
              prodData.ManufacturerPartNumber ||
              prodData.ERPMFRPartNumber ||
              "",
            quantityAddedToBOM: prodData?.Quantity || prodData?.quantity,
            quantityAvailableForSale: prodData?.qas,
            backOrderedQuantity:
              prodData?.backOrderedQuantity ||
              prodData?.backOrderQuantity ||
              "",
            displayedPrice: prodData?.unitPrice || "",
            displayedPriceType: prodData?.priceSource || "",
            dateTimestamp: this.timeStamp(),
          },
        };
        productListItems.push(obj);
      });
      return productListItems;
    }
  }

  static arrangeProductsLists(prodDetails, cartDetails, quoteCartType) {
    if (prodDetails) {
      let catArr = [];
      function categoryArr(catData) {
        catData.forEach((cat, key) => {
          catArr.push(cat.value);
        });
        let catArrStr = catArr.length ? catArr.join() : catArr;
        return catArrStr;
      }

      let productListItems = [];
      prodDetails.forEach((prodData, key) => {
        let obj = {
          SKU: prodData.ItemNumber || prodData.itemNumber || prodData.sku || "",
          name:
            prodData.ERPPartNumber ||
            prodData.ERPMFRPartNumber ||
            prodData.erpMfrPartNumber ||
            prodData.partNumber ||
            prodData?.translatedManufacturerPartNumber ||
            "",
          currencyCode:
            prodData.currency || prodData.quoteCurrency || window.mct || "",
          quantity:
            prodData.quantity || prodData.Quantity || prodData.quantity1 || prodData.translatedMinimumOrderQuality,
          priceTotal: prodData.subtotal ? prodData.subtotal.toFixed(2) : "",
          productImageUrl: prodData.assetURL || prodData?.productURL ||  "",
          category: prodData?.categoryListing?.length
            ? categoryArr(prodData.categoryListing)
            : "",
          merchandising: {
            erpPartKey:
              prodData.ERPPartNumber ||
              prodData.ERPMFRPartNumber ||
              prodData.erpMfrPartNumber ||
              prodData.partNumber ||
              "",
            pimPartKey: prodData.ItemNumber || prodData.itemNumber || "",
            supplierID: prodData.ERPSupplierCode || "", //Phani
            supplierPartNumber: prodData.supplierPartNumber || "", //Phani
            manufacturerID:
              prodData.ManufacturerCode ||
              prodData.manufacturerCode ||
              prodData.ERPManufacturerCode ||
              prodData?.vendorId ||
              "",
            manufacturerName:
              prodData.ManufacturerName ||
              prodData.manufacturerName ||
              prodData.ERPManufacturerName ||
              prodData.vendorName ||
              "",
            manufacturerPartNumber:
              prodData.manufacturerPartNumber ||
              prodData.ManufacturerPartNumber ||
              prodData.ERPMFRPartNumber ||
              prodData.translatedManufacturerPartNumber ||
              "",
            quantityAvailableForSale: prodData.qas || prodData?.inv,
            backOrderedQuantity: prodData.backOrderedQuantity || "",
            priceType: prodData.priceSource || "",
            dateTimestamp: this.timeStamp(),
            displayedPrice: prodData.unitPrice || "",
          },
        };
        // Newark Items
        if (prodData.sku && prodData?.inv) {
          delete obj['category'];
          obj.merchandising = {
            category: prodData?.categoryListing?.length && categoryArr(prodData.categoryListing) || "",
            ...obj.merchandising,
          }
        }
        //If quote value is present
        if (quoteCartType) {
          let newMerchandising = { ...obj.merchandising };
          if (
            prodData?.quoteLineItemId ||
            prodData?.quoteID ||
            cartDetails?.quoteID
          ) {
            newMerchandising.quoteID =
              prodData?.quoteLineItemId ||
              cartDetails?.quoteID ||
              prodData.quoteID;
          }
          if (prodData?.quoteSource || cartDetails?.quoteType) {
            newMerchandising.quoteType =
              prodData?.quoteSource || cartDetails?.quoteType || "";
          }
          obj.merchandising = newMerchandising;
        }
        //If cart AdditionSource
        if (cartDetails) {
          let cartAddSource = { ...obj.merchandising };
          if (cartDetails?.additionSource) {
            cartAddSource.cartAdditionSource =
              cartDetails?.additionSource || "";
          }
          cartAddSource.cartType = cartDetails?.cartType || "";
          obj.merchandising = cartAddSource;
        }

        productListItems.push(obj);
      });
      return productListItems;
    }
  }

  static timeStamp() {
    const now = new Date();
    const timeStamp = now.toISOString();
    return timeStamp;
  }

  static removeLocalStorageEvent() {
    localStorage.removeItem("adobeEventType");
  }
}
export default HelperAdobeEvent;
